
import {Component, Vue, Prop} from "vue-property-decorator";
import SummarySection from "@/components/utils/SummarySection.vue";
import preferencesService from "@/services/preferences.service";
import {namespace} from "vuex-class";
import frontService from "../../../services/front.service";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";
import IComptage from "@/types/comptage.interface";

const userModule = namespace("userModule");

@Component({
    components: {SummarySection, TooltipDialog}
})
export default class PreferenceSelectionEnrichissement extends Vue {
    @Prop() readonly filePreferenceSelect;
    @Prop() readonly filePreference;
    @Prop() readonly filePreferenceLoading;

    @userModule.State
    public user: any;

    preferenceModification = {
        name: '',
        datas: [],
        uuid: null,
        id: null,
        date: null
    };
    preferenceToDelete = {
        name: "",
        type: ""
    };
    dialogSavePreferences = false;
    deleteModal = false;

    headers = [
        {
            text: "Nom",
            value: "name",
            width:'25vmax'
        },
        {
            text: "Date",
            value: "date",
            filterable: false,
            align: 'center',
            width:'20vmax'
        },
        {text: "Actions", value: "actions", sortable: false}
    ];
    search = "";

    editItem(item) {
        this.preferenceModification = JSON.parse(JSON.stringify(item));
        this.dialogSavePreferences = true;
    }

    deleteItem(item) {
        this.preferenceToDelete = item;
        this.deleteModal = true;
    }

    savePreferenceFilter() {
        preferencesService.savePreferenceFilter({
            datas: this.preferenceModification.datas,
            name: this.preferenceModification.name,
            uuid: this.preferenceModification.uuid,
            id: this.preferenceModification.id,
            date: this.preferenceModification.date
        }, this.user.id, 'enrichment').then(res => {
            if (this.filePreferenceSelect[0] && (this.filePreferenceSelect[0].uuid === this.preferenceModification.uuid)) {
                this.$emit('filePreferenceSet', [this.preferenceModification]);
            }
            this.$emit('save-preference', true);
            this.$emit('refresh');
        });
    }

    removeDataToAdd(data) {
        this.preferenceModification.datas = this.preferenceModification.datas.filter(obj => obj !== data);
    }

    customSort(items, index, isDesc) {
        return frontService.customSort('date', items, index, isDesc);
    }

    img(value) {
        return require('@/assets/' + value);
    }

    customFilter(value, search, item) {
        if(this.search) {
            const finalSearch = this.search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            const finalValue = item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            return finalValue.includes(finalSearch);
        } else {
            return false;
        }
    }
}

